export default __webpack_public_path__ + "static/media/tiktok.8c5cffd4.svg";